import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {MessageService, ConfirmationService, LazyLoadEvent} from 'primeng/api';
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MsgRecipient } from "../msg-recipient";
import { MsgRecipientService } from "../msg-recipient.service";

@Component({
    selector: "app-msg-recipient",
    templateUrl: "./msg-recipient.component.html",
    styleUrls: ["./msg-recipient.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class MsgRecipientComponent implements OnInit {
  msgId: any;
  constructor(
    private primengConfig: PrimeNGConfig,
    private msgRecipientService: MsgRecipientService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private constantService: ConstantService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    (this.formTitle = data.title), (this.msgRecipient = data.msgRecipient);
    this.msgId = data.msgId;
    this.countries = this.constantService.countries;
    // this.statuses = msgRecipientService.statuses;
  }

  @Input() msgRecipient: MsgRecipient;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  msgRecipientId: number;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  emailRecipientTypes: any;

  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  validationMessages = {
    msgRecipientId: [],
    firstName: [],
    lastName: [],
    email: [],
    mobileNum: [{ type: 'required', message: 'Required' }],
    emailRecipientType: [],
    mobileCountryCode: [],
    // msgAPI: [],
  };
  countries: any;

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.emailRecipientTypes = this.msgRecipientService.emailRecipientTypes;
    this.formBuild();

    // if we were passed the whole msgRecipient object
    if (this.msgRecipient) {
      this.msgRecipientId = this.msgRecipient.msgRecipientId;
      this.fixDates();
      this.form1.patchValue(this.msgRecipient);
    }
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.msgRecipientId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.form1.value.msgId = this.msgId;
      this.msgRecipientService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgRecipient = res.data.msgRecipient;
          this.doAdd.emit(this.msgRecipient);
        },
        (err: any) => {
          console.log("msgRecipient-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("msgRecipient: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.msgRecipientService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msgRecipient = res.data.msgRecipient;
          this.doUpdate.emit(this.msgRecipient);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.msgRecipientService
        .delete(this.msgRecipient.msgRecipientId)
        .subscribe(
          (res: any) => {
            console.log("msgRecipient-delete SUCCESS: " + JSON.stringify(res));
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.msgRecipient);
          },
          (err: any) => {
            console.log("msgRecipient-add FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      msgRecipientId: [this.msgRecipientId],
      firstName: [],
      lastName: [],
      email: [],
      mobileNum: [],
      mobileCountryCode: [],
      emailRecipientType: [],
      msgAPI: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
  }
}
